"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _blocks = require("@bueno/blocks");

var _unassociate = require("../../../redux/modules/_BETA/unassociate");

var _AssociateMenuItem = require("../../ActionModals/AssociateAction/components/AssociateMenuItem");

const RowAction = ({
  actionId,
  onMenuToggle,
  equipRuleId,
  occurrenceId,
  isAssociated,
  unassociate,
  showCreateAction,
  handleLastClickedModal
}) => {
  const handleSetActiveRow = _react.default.useCallback(() => {
    handleLastClickedModal(occurrenceId);
  }, [occurrenceId]);

  return /*#__PURE__*/_react.default.createElement(_blocks.Menu, {
    onMenuOffClickClose: () => onMenuToggle(false)
  }, ({
    isOpen,
    toggle,
    close
  }) => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.IconButton, {
    icon: /*#__PURE__*/_react.default.createElement(_blocks.ActionsMenuLarge, null),
    onClick: () => {
      toggle();
      onMenuToggle(!isOpen);
    }
  }), isOpen ? /*#__PURE__*/_react.default.createElement(_blocks.Popover, {
    right: true
  }, /*#__PURE__*/_react.default.createElement(_blocks.ActionHeading, null, "ACTIONS"), /*#__PURE__*/_react.default.createElement(_blocks.ActionList, null, !isAssociated && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.ActionItemButton, {
    onClick: () => {
      showCreateAction(equipRuleId, occurrenceId);
      close();
      onMenuToggle(false);
    }
  }, "Associate to new Action"), /*#__PURE__*/_react.default.createElement(_AssociateMenuItem.AssociateMenuItem, {
    equipRuleIds: [equipRuleId],
    onShowModal: handleSetActiveRow
  }, /*#__PURE__*/_react.default.createElement(_blocks.ActionItemButton, null, "Associate to existing Action"))), isAssociated && /*#__PURE__*/_react.default.createElement(_blocks.ActionItemButton, {
    type: "button",
    onClick: unassociate(equipRuleId, actionId, () => {
      close();
      onMenuToggle(false);
    })
  }, "Unassociate from Action"))) : null));
};

function mapDispatchToProps(dispatch) {
  return {
    unassociate: (equipRuleId, actionId, cb) => () => {
      dispatch((0, _unassociate.unassociateEquipRule)({
        equipRuleIds: [equipRuleId],
        actionId
      }));
      if (typeof cb === 'function') cb();
    }
  };
}

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(RowAction);

exports.default = _default;
module.exports = exports.default;